export default {
  ROLE_SAF: 0,
  ROLE_CLUB: 1,
  REQUERIMIENTO_HAS_TEXT: 0,
  REQUERIMIENTO_HAS_NUMBER: 1,
  REQUERIMIENTO_ONLY_HAS_ATTACH: 2,
  REQUERIMIENTO_HAS_BOOLEAN: 3,
  REQUERIMIENTO_HAS_PHONE: 4,
  REQUERIMIENTO_HAS_EMAIL: 5,
  REQUERIMIENTO_HAS_DIRECTION: 6,
  NO_PRESENTADO: 'No presentado',
  REVISADO_INCOMPLETO: 'Revisado incompleto',
  REVISADO_OK: 'Revisado ok',
  A_REVISAR: 'A Revisar',
  CONTRACT_VERIFIED: 2,
  CONTRACT_PENDING: 3,
  CONTRACT_REJECTED: 4,
  CONTRACT_ENDED: 5,
  ALLOWED_IMAGE_EXTENSIONS: /\.(jpeg|jpg|png|gif|jfif)$/,
  EN_CARGA: 'En carga',
  A_SUBSANAR: 'A subsanar',
  ARS: 1,
  USD: 2,
  EUR: 3,
  REAL: 4,
  BRUTO: 0,
  NETO: 1,
  INFORME_FIELD_IS_STRING: 1,
  INFORME_FIELD_IS_NUMERICAL: 2,
  INFORME_FIELD_IS_PHONE: 3,
  INFORME_FIELD_IS_EMAIL: 4,
  INFORME_FIELD_IS_ARBITRO: 5,
  INFORME_FIELD_IS_DIRECTOR: 6,
  INFORME_FIELD_IS_ESTADIO: 7,
  INFORME_FIELD_IS_FECHA: 8,
  INFORME_FIELD_IS_PARTIDO: 9,
  INFORME_FIELD_IS_TORNEO: 10,
  INFORME_FIELD_IS_EQUIPO_LOCAL: 11,
  INFORME_FIELD_IS_EQUIPO_VISITANTE: 12,
  INFORME_FIELD_IS_BOOLEAN: 13,
  INFORME_FIELD_IS_DATE: 14,
  INFORME_FIELD_IS_TIME: 15,
  INFORME_STATUS_EN_CARGA: 0,
  INFORME_STATUS_PRESENTADO: 1,
  INFORME_STATUS_APROBADO: 2,
  INFORME_FIELD_IS_TEXTO_LARGO: 16,
  INFORME_MODULO_GENERAL: 1,
  INFORME_MODULO_PARTIDO: 2,
  IS_FIELD_WRONG: 'Falta',
  IS_FIELD_OK: 'Ok',
  IS_FIELD_WARNING: 'Advertencia',
  IS_FIELD_REVISAR: 'Revisar',
  IS_FIELD_VALID: 'Valido',
  INFORME_STATUS_DEVUELTA: 3,
  INFORME_FIELD_FOTO: 17,
  INFORME_FIELD_VISIBILITY_LOCAL: 0,
  INFORME_FIELD_VISIBILITY_VISITANTE: 1,
  INFORME_FIELD_VISIBILITY_TODOS: 2,
  INFORME_FIELD_VISIBILITY_LIGA: 3,
  IMG_COMPRESSOR_QUALITY: 0.2,
  INFORME_FIELD_IS_TIME_MANUAL: 18,
  INFORME_FIELD_IS_CONTACTO_OPERATIVO: 19,
  CONTRACT_TYPE_AFA: 'AFA',
  INFORME_FIELD_IS_SI_NO_NA: 21,
  IS_FIELD_REVISADO_OK: 'Revisado OK',
  IS_FIELD_ADVERTENCIA: 'Advertencia',
  IS_FIELD_INCUMPLIMIENTO: 'Incumplimiento',
  PLAYER_ROL_JUGADOR: 4,
  INFORME_FIELD_ARBITRO_RESERVA: 22,
  INFORME_FIELD_ESTADIO_RESERVA: 23,
  INFORME_FIELD_OFICIAL_SEGURIDAD: 24

}
